export enum E_ManageFeatures {
  ONLINE_SIGNING_AUTO_SWITCH_ON = "online-signing-auto-switch-on",
}
export enum E_PatientFeatures {
  EMERGENCY_CONTACT = "emergency-contact",
  PATIENT_GP_DETAILS = "patient-gp-details",
}

export type E_Features = E_ManageFeatures | E_PatientFeatures;
